import { Component, inject, Inject, ViewEncapsulation } from '@angular/core';
import {
	MatSnackBarRef,
	MAT_SNACK_BAR_DATA
} from '@angular/material/snack-bar';

@Component({
	selector: 'app-custom-alert',
	templateUrl: './custom-alert.component.html',
	styleUrls: ['./custom-alert.component.scss'],
	encapsulation: ViewEncapsulation.None
})
export class CustomAlertComponent {
	snackBarRef = inject(MatSnackBarRef);
	constructor(
		@Inject(MAT_SNACK_BAR_DATA)
		public data: {
			message: string;
			action: string;
			icon: string;
		}
	) {}
}
